var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 18C15.551 18 16 18.448 16 19C16 19.552 15.551 20 15 20C14.448 20 14 19.552 14 19C14 18.448 14.448 18 15 18ZM9 18C9.551 18 10 18.448 10 19C10 19.552 9.551 20 9 20C8.448 20 8 19.552 8 19C8 18.448 8.448 18 9 18ZM19.889 3.458L15.894 11.447C15.725 11.786 15.378 12 15 12H7C6.447 12 6 12.448 6 13C6 13.552 6.447 14 7 14H17C17.551 14 18 14.448 18 15C18 15.552 17.551 16 17 16C17 16 10.413 16 7 16C5.343 16 4 14.657 4 13C4 11.793 4.71201 10.753 5.73901 10.277L3.25601 2H1C0.448 2 0 1.552 0 1C0 0.448 0.448 0 1 0H4C4.441 0 4.83 0.29 4.957 0.713L5.34403 2H18.988C19.067 1.999 19.147 2.007 19.225 2.026L19.233 2.028C19.326 2.05 19.413 2.085 19.494 2.131C19.644 2.216 19.765 2.335 19.85 2.474C19.936 2.613 19.989 2.774 19.998 2.947C20.003 3.039 19.995 3.133 19.974 3.226L19.972 3.234C19.953 3.313 19.925 3.388 19.889 3.458ZM17.382 4H5.944L7.74402 10H14.382L17.382 4Z",
    fill: "#363636"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/Cart.32bc07cecc0d0f73df03c866410f4cc0.svg";
export { ForwardRef as ReactComponent };